import { useContext } from "react";
import { Stack, Typography, Grid, Box } from "@mui/material";
import moment from "moment";
//Import from project
import "../../Style/pagestyle.scss";
import LoginImage from "../../Assets/logoSystem.png";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import LoadingPage from "../../Utils/LoadingPage";
import EmptyData from "../Include/EmptyData/EmptyData";
import useGetInvoiceByPaymentStatusReport from "../../Hooks/useGetInvoiceByPaymentStatusReport";
import {
  currencyFormat,
  generateInvoiceNumber,
} from "../../Function/DynamicFn";

export default function InvoiceByPaymentStatus({
  componentRef,
  paymentStatus,
  fromDate,
  toDate,
  groupFeeType,
}) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const { tableData, loading } = useGetInvoiceByPaymentStatusReport({
    paymentStatus,
    fromDate,
    toDate,
    groupFeeType,
  });

  // console.log("tableData::", tableData);
  const totalOwe = tableData?.invoiceData?.reduce(
    (sum, item) => sum + item.totalOwe,
    0
  );
  const totalAmount = tableData?.invoiceData?.reduce(
    (sum, item) => sum + item.totalAmount,
    0
  );
  const totalReceived = tableData?.invoiceData?.reduce(
    (sum, item) => sum + item.totalReceived,
    0
  );

  const translatePaymentStatus = (status) => {
    if (status === "Paid") return t("thead_paid");
    if (status === "Unpaid") return t("thead_unpaid");
    if (status === "Owe") return t("thead_owe");
    else return status;
  };

  return (
    <div className="page-container">
      <Stack
        sx={{ padding: "20px" }}
        direction={"column"}
        spacing={1}
        ref={componentRef}
      >
        <Box>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <Stack direction="row" justifyContent={"left"}>
                <img alt="Logo" src={LoginImage} style={{ width: "120px" }} />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Typography className="report-table-title">
                {t("invoice_list")}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {/* ================================ Table student and parents info ============================ */}
        <table className="report-table-container">
          <thead>
            <tr>
              <th style={{ width: "4%" }}>{t("no")}</th>
              <th style={{ width: "14%" }}>{t("thead_invoice_id")}</th>
              <th style={{ width: "20%" }}>
                {t("thead_student")} / {t("thead_other")}
              </th>
              <th style={{ width: "10%" }}>{t("thead_date")}</th>
              <th style={{ width: "10%" }}>{t("thead_status")}</th>
              <th style={{ width: "12%" }}>{t("thead_owe_amount")}</th>
              <th style={{ width: "12%" }}>{t("thead_total_receive")}</th>
              <th style={{ width: "12%" }}>{t("thead_total_amount")}</th>
            </tr>
          </thead>

          {loading ? (
            <tbody>
              <tr>
                <td colSpan={16}>
                  <LoadingPage />
                </td>
              </tr>
            </tbody>
          ) : (
            <>
              {tableData?.invoiceData?.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan={16}>
                      <EmptyData />
                    </td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  {tableData?.invoiceData?.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td align="center">{index + 1}</td>
                        <td align="center">
                          {generateInvoiceNumber(
                            row?.invoiceNumber,
                            row?.createdAt
                          )}
                        </td>
                        <td>
                          {row?.studentId?.familyName +
                            " " +
                            row?.studentId?.studentName}
                        </td>
                        <td align="center">
                          {row?.date && moment(row?.date).format("DD-MMM-YYYY")}
                        </td>
                        <td align="center">
                          {translatePaymentStatus(row?.paymentStatus)}
                        </td>
                        <td align="right">{`$ ${currencyFormat(
                          row?.totalOwe
                        )}`}</td>
                        <td align="right">
                          $ {currencyFormat(row?.totalReceived || 0)}
                        </td>
                        <td align="right">
                          $ {currencyFormat(row?.totalAmount || 0)}
                        </td>
                      </tr>
                    );
                  })}

                  <tr>
                    <th colSpan="5" align="center">
                      Total
                    </th>
                    <th style={{ color: "orange", textAlign: "right" }}>
                      $ {currencyFormat(totalOwe)}
                    </th>
                    <th style={{ color: "green", textAlign: "right" }}>
                      $ {currencyFormat(totalReceived)}
                    </th>
                    <th style={{ color: "red", textAlign: "right" }}>
                      $ {currencyFormat(totalAmount)}
                    </th>
                  </tr>
                </tbody>
              )}
            </>
          )}
        </table>
      </Stack>
    </div>
  );
}
